import { camelToPascal } from '../caseConverters/camelToPascal'

export const formatFilterValue = (filterValue: string) => {
    if (filterValue.includes('T00:00:00.000Z')) {
        return filterValue.slice(0, 10)
    }
    return camelToPascal(filterValue)
}
